import React from 'react';

const About = () => {
  return (
    <div className="px-6 md:px-12 py-12 max-w-3xl" data-testid="about-page">
      <h1 className="detail-header text-xl md:text-2xl mb-10">About</h1>

      <div className="space-y-6 text-sm leading-relaxed text-gray-600">
        <p>
          Photography is not just about capturing an image. It's about capturing an emotion,
          an idea, a moment that lives on forever.
        </p>

        <p>
          At <strong className="text-black">Studio Varad Anvekar</strong>, we offer Architectural
          & Interior photography in the expansive field of architecture and interior design.
          We lend support to our clients to showcase their passionate work in the most desired,
          aesthetic & creative manner.
        </p>

        <p>
          We help leading as well as beginner Architects, Interior designers, entrepreneurs
          and freelancers to build their design folio, document their projects, cover design
          details & artwork, and develop effective design videos.
        </p>

        <div className="pt-6 border-t border-gray-100">
          <div className="tool-label mb-4">Services</div>
          <ul className="space-y-2 text-sm text-gray-600">
            <li>Architectural Photography</li>
            <li>Interior Design Photography</li>
            <li>Real Estate Photography</li>
            <li>Product Photography</li>
            <li>Architectural & Interior Design Video</li>
            <li>Instagram Reels & Walkthroughs</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
